export default __webpack_public_path__ + "static/media/college.6b6669ad.PNG";